/**
 * hexToRGB
 * Converts a hex color value to RGB and applies an opacity
 * Used in some visualizations to desaturate chart colors
 */
export function hexToRGB(hexColor: string, opacity: number): string {
    const hexWithoutHash = hexColor.replace("#", "");
    const r = parseInt(hexWithoutHash.substring(0, 2), 16);
    const g = parseInt(hexWithoutHash.substring(2, 4), 16);
    const b = parseInt(hexWithoutHash.substring(4, 6), 16);
    return `rgb(${r}, ${g}, ${b}, ${opacity})`;
}
